import moment from 'moment/min/moment-with-locales';
import 'moment/locale/nl';

moment.locale('nl');

export const date = (date) => moment(date).format('DD-MM-YYYY');
export const dateTime = (dateTime) => moment(dateTime).format('DD-MM-YYYY HH:mm');
export const longDate = (date) => moment(date).locale('nl').format('dddd D MMMM YYYY - HH:mm');
export const shortDate = (date) => moment(date).format('DD-MM-YYYY');
export const shortDateWritten = (date) => moment(date).format('dddd D MMMM YYYY');
export const oneDecimal = (value) => parseFloat(value).toFixed(1);

export default {
    date,
    dateTime,
    oneDecimal,
    longDate,
    shortDate
};
